import { Accordion } from "components/DesignSystem/Accordion/Accordion";
import { Button } from "components/DesignSystem/Button/Button";
import { FieldBuilder } from "./FieldBuilder";
import { EntityDataAttribute } from "types/Models/entity";
import { EditPencil } from "components/icons/EditPencil";
import { CaretDown } from "components/icons/CaretDown";

export const EntityDataAttributeAccordion = ({
  title,
  subtitle,
  icon,
  content,
  extraFields = [],
  onChange,
  editEntityName,
  onEditClick,
  onSave,
  isDisabled,
  hasChanges,
  onCancelEdit,
}: {
  title: string;
  subtitle: string;
  icon: React.ReactNode;
  content: React.ReactNode;
  extraFields?: EntityDataAttribute[];
  onChange?: ({
    name,
    value,
  }: {
    name: string;
    value: EntityDataAttribute["value"];
  }) => void;
  editEntityName?: () => void;
  onEditClick?: () => void;
  onSave?: () => void;
  isDisabled: boolean;
  hasChanges: boolean;
  onCancelEdit: () => void;
}) => {
  const onEdit = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    onEditClick?.();
  };
  return (
    <Accordion.Item key={title} value={title}>
      <Accordion.Trigger
        className="all:unset t-flex t-gap-2 t-group t-w-full t-normal-case"
        showArrow={false}
      >
        <div className="t-flex t-items-center t-gap-3">
          <div className="t-text-text-30">
            <div className="t-h-[46px] t-w-[46px] t-justify-center t-items-center t-flex t-bg-surface-grey t-rounded-full">
              {icon}
            </div>
          </div>
          <div className="t-space-y-1">
            <div className="t-text-subtext t-text-text-100">{title}</div>
            <div className="t-text-body-sm t-text-text-30">{subtitle}</div>
          </div>
        </div>
        <div className="t-flex t-items-center t-gap-3">
          {isDisabled && (
            <Button
              type="button"
              customType="ghost"
              size="small"
              onClick={onEdit}
              leftIcon={<EditPencil />}
            >
              Edit
            </Button>
          )}
          <span className="group-data-state-open:-t-rotate-180 group-data-state-closed:t-rotate-0 t-text-neutral t-transform t-transition t-duration-300 t-ease-in-out">
            <CaretDown />
          </span>
        </div>
      </Accordion.Trigger>
      <Accordion.Content className="t-text-body-sm t-text-text-30 t-flex t-flex-col t-gap-4">
        {extraFields && extraFields.length > 0 && (
          <div className="t-flex t-justify-between">
            {extraFields.map((field, index) => (
              <div className="t-flex t-items-center" key={field.uuid}>
                {index > 0 && (
                  <div className="t-h-6 t-w-[1px] t-bg-neutral-0 t-mx-6"></div>
                )}
                <FieldBuilder
                  field={{ ...field, disabled: field.disabled || isDisabled }}
                  onChange={onChange}
                  editEntityName={isDisabled ? undefined : editEntityName}
                />
              </div>
            ))}
          </div>
        )}
        {content}
        {!isDisabled && (
          <div className="t-flex t-justify-end t-gap-2">
            <Button
              type="button"
              size="xsmall"
              customType="ghost"
              onClick={onCancelEdit}
            >
              Cancel
            </Button>
            <Button
              type="button"
              size="xsmall"
              onClick={onSave}
              customType="primary"
              disabled={!hasChanges}
            >
              Save Changes
            </Button>
          </div>
        )}
      </Accordion.Content>
    </Accordion.Item>
  );
};
